import React, { useState } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router";
import { useMutation } from "@apollo/react-hooks";

import Link from "core/Link";
import PhotoUploadCancelModal from "./PhotoUploadCancelModal";

import { PHOTO_UPLOAD } from "data/links";
import { WITHDRAW_PHOTO_BATCH } from "./mutations";

import { usePhotoUpload } from "frontend/hooks/usePhotoUpload";

const PhotoUploadCancel = ({
    uploadsInDropzoneCount = 0,
    failedUploadCount = 0,
    currentlyProcessingCount = 0
}) => {
    const history = useHistory();
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const { clearUploadRegistrationErrors } = usePhotoUpload();

    const [withdrawPhotoBatch] = useMutation(WITHDRAW_PHOTO_BATCH, {
        // will redirect to photo upload view page once batch withdrawal is complete
        // photo upload view page will use `FetchExistingUploads` query to determine view
        refetchQueries: [
            "FetchUploadBatches",
            "GetPhotoShootForAddingPhotoUploads"
        ],
        onCompleted: () => {
            clearUploadRegistrationErrors();
            history.replace(PHOTO_UPLOAD);
        }
    });

    const handleCancelButtonClick = () => {
        // show modal only if user has uploaded any files
        if (!uploadsInDropzoneCount && !failedUploadCount) {
            withdrawPhotoBatch();
        } else {
            setModalIsOpen(true);
        }
    };

    return (
        <>
            <Link
                onClick={handleCancelButtonClick}
                size="md"
                styleType="primary"
                isButton
                disableVisitedStyle
                isDisabled={!!currentlyProcessingCount}
            >
                Cancel
            </Link>
            <PhotoUploadCancelModal
                modalIsOpen={modalIsOpen}
                closeModal={() => setModalIsOpen(false)}
                withdrawPhotoBatch={withdrawPhotoBatch}
            />
        </>
    );
};

PhotoUploadCancel.propTypes = {
    uploadsInDropzoneCount: PropTypes.number.isRequired,
    failedUploadCount: PropTypes.number.isRequired,
    currentlyProcessingCount: PropTypes.number.isRequired
};

export default PhotoUploadCancel;
